import { preventMarkerSettingsConflictsSaga } from './consistency/preventMarkerSettingsConflicts.saga';
import { removeDeletedRowsLabelOffsetsSaga } from './consistency/removeDeletedRowsLabelOffsets';
import { removeDeletedRowsMarkerImagesSaga } from './consistency/removeDeletedRowsMarkerImages.saga';
import { removeDeletedRowsPriorityMarkersSaga } from './consistency/removeDeletedRowsPriorityMarkers';

export function* mapSettingsMarkersSaga() {
  yield* removeDeletedRowsMarkerImagesSaga();
  yield* removeDeletedRowsLabelOffsetsSaga();
  yield* preventMarkerSettingsConflictsSaga();
  yield* removeDeletedRowsPriorityMarkersSaga();
}
